import {Exclude, Expose, Type} from 'class-transformer';
import {AbstractApiModel} from '../abstract.api.model';
import {MediaObjectApiModel} from '../media-object.api-model';
import {UserApiModel} from '../user.api-model';

@Exclude()
export class ProjectCollaborationAssetApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public collaboration: string | {'@id'?: string; id?: number};
  @Expose() public mediaPost: string | {'@id'?: string; id?: number};
  @Type(() => MediaObjectApiModel)
  @Expose() public media: string | MediaObjectApiModel;
  @Type(() => UserApiModel)
  @Expose() public createdBy: string | UserApiModel;
  @Type(() => UserApiModel)
  @Expose() public approvedBy: string | UserApiModel;
  @Type(() => UserApiModel)
  @Expose() public rejectedBy: string | UserApiModel;
  @Expose() public status: string;
  @Expose() public caption: string;
  @Expose() public reviewNote: string;
  @Expose() public ownerDecisionAt: Date;
  @Expose() public approvedAt: Date;
  @Expose() public rejectedAt: Date;
  @Expose() public isVisibleInBaseProject: boolean;
  @Expose() public syncedToBaseProjectAt: Date;
  @Expose() public orderPosition: number;
  @Expose() public mediaPostOrderPosition: number;
  @Expose() public createdAt: Date;
  @Expose() public updatedAt: Date;
}
